<template>
  <div id="contenedor-imagenes-carouseles">
    <v-carousel :value="currentIndex" hide-delimiters @change="cambioDeImagen">
      <template v-for="(imagen, index) in imagenes">
        <template>
          <v-carousel-item
            :key="`imagen-${index}`"
            :src="imagen.url"
            max-width="100%"
            max-heigth="100%"
            contain
            aspect-ratio="16/9"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <v-row justify="end" class="pt-6">
              <v-tooltip top :key="`descargarimagen-${index}`">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="descargarImagen(imagen)"
                    icon
                    :loading="mostrarDescargando"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon large color="blue darken-1"> mdi-cloud-download </v-icon>
                  </v-btn>
                </template>
                <span>Descargar Imagen</span>
              </v-tooltip>
            </v-row>
          </v-carousel-item>
        </template>
      </template>
    </v-carousel>
    <v-row justify="center">
      <custom-button
        @click="cerrar"
        tipo="formCancelar"
        label="Cerrar"
        class="mr-3"
      >
      </custom-button>
    </v-row>
  </div>
</template>

<script>
import fileDownload from 'js-file-download';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ImagenCarouselsDiarioActividades',
  props: {
    // los objetos del array de imagenes deben contender 2 propiedades:
    // { url: 'url de la imagen', titulo:'titulo de la imagen para asignarse al descargar'}
    imagenes: {
      type: Array,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      mostrarDescargando: false,
      wup: this.currentIndex,
      imagenSeleccionada: '',
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    async descargarImagen(imagen) {
      this.mostrarDescargando = true;
      await this.axios
        .get(`${imagen.url}`, {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.progresoDescarga = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        })
        .then((res) => {
          fileDownload(res.data, `${imagen.titulo}.jpg`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.mostrarDescargando = false;
    },
    cambioDeImagen(e) {
      const imagen = this.imagenes[e];
      this.$emit('cambioDeImagen', imagen);
    },
  },
};
</script>

<style lang="scss">
</style>
